// Comprehensive mock data for PropFirmHouse Admin Panel

// Generate realistic mock data
const generateSparklineData = () => {
  return Array.from({ length: 30 }, () => Math.floor(Math.random() * 100 + 50));
};

export const mockPropFirms = [
  {
    id: '1',
    name: 'FTMO',
    slug: 'ftmo',
    logo: 'https://placehold.co/40x40/1A3C6B/FFF?text=FT',
    country: 'Czech Republic',
    rating: 4.8,
    reviewCount: 245,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: true,
    featuredOrder: 1,
    createdAt: '2025-11-15T10:00:00Z',
    affiliateUrl: 'https://ftmo.com/?ref=propfirmhouse',
    startingPrice: 155,
    maxFunding: 200000,
    profitSplit: 80,
    description: 'FTMO is one of the most established prop firms with a solid reputation.',
    tradingRules: {
      allowed: ['News Trading', 'Weekend Holding', 'EA / Bots', 'Copy Trading'],
      notAllowed: ['Martingale Strategy', 'HFT Scalping under 1 min']
    },
    faqs: [
      { question: 'What is the evaluation process?', answer: 'FTMO uses a 2-step evaluation process.' },
      { question: 'How long does verification take?', answer: 'Typically 1-3 business days.' }
    ]
  },
  {
    id: '2',
    name: 'The5ers',
    slug: 'the5ers',
    logo: 'https://placehold.co/40x40/2A5298/FFF?text=T5',
    country: 'Israel',
    rating: 4.5,
    reviewCount: 189,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: true,
    featuredOrder: 2,
    createdAt: '2025-10-20T14:30:00Z',
    affiliateUrl: 'https://the5ers.com/?ref=propfirmhouse',
    startingPrice: 199,
    maxFunding: 250000,
    profitSplit: 75,
  },
  {
    id: '3',
    name: 'Funded Next',
    slug: 'funded-next',
    logo: 'https://placehold.co/40x40/10B981/FFF?text=FN',
    country: 'United States',
    rating: 4.7,
    reviewCount: 312,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: true,
    featuredOrder: 3,
    createdAt: '2025-11-28T09:15:00Z',
    affiliateUrl: 'https://fundednext.com/?ref=propfirmhouse',
    startingPrice: 99,
    maxFunding: 300000,
    profitSplit: 85,
  },
  {
    id: '4',
    name: 'MyFundedFX',
    slug: 'myfundedfx',
    logo: 'https://placehold.co/40x40/F59E0B/FFF?text=MF',
    country: 'United Kingdom',
    rating: 4.4,
    reviewCount: 156,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-12-05T11:00:00Z',
    affiliateUrl: 'https://myfundedfx.com/?ref=propfirmhouse',
    startingPrice: 149,
    maxFunding: 150000,
    profitSplit: 80,
  },
  {
    id: '5',
    name: 'Topstep',
    slug: 'topstep',
    logo: 'https://placehold.co/40x40/1A3C6B/FFF?text=TS',
    country: 'United States',
    rating: 4.6,
    reviewCount: 203,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-09-10T08:45:00Z',
    affiliateUrl: 'https://topstep.com/?ref=propfirmhouse',
    startingPrice: 165,
    maxFunding: 150000,
    profitSplit: 80,
  },
  {
    id: '6',
    name: 'True Forex Funds',
    slug: 'true-forex-funds',
    logo: 'https://placehold.co/40x40/2A5298/FFF?text=TF',
    country: 'United States',
    rating: 4.3,
    reviewCount: 98,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-12-18T16:20:00Z',
    affiliateUrl: 'https://trueforexfunds.com/?ref=propfirmhouse',
    startingPrice: 129,
    maxFunding: 200000,
    profitSplit: 75,
  },
  {
    id: '7',
    name: 'Alpha Capital',
    slug: 'alpha-capital',
    logo: 'https://placehold.co/40x40/10B981/FFF?text=AC',
    country: 'United Kingdom',
    rating: 4.7,
    reviewCount: 178,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-11-01T13:10:00Z',
    affiliateUrl: 'https://alphacapital.com/?ref=propfirmhouse',
    startingPrice: 179,
    maxFunding: 200000,
    profitSplit: 80,
  },
  {
    id: '8',
    name: 'E8 Markets',
    slug: 'e8-markets',
    logo: 'https://placehold.co/40x40/EF4444/FFF?text=E8',
    country: 'United States',
    rating: 4.5,
    reviewCount: 134,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-10-15T10:30:00Z',
    affiliateUrl: 'https://e8markets.com/?ref=propfirmhouse',
    startingPrice: 139,
    maxFunding: 250000,
    profitSplit: 80,
  },
  {
    id: '9',
    name: 'Instant Funding',
    slug: 'instant-funding',
    logo: 'https://placehold.co/40x40/1A3C6B/FFF?text=IF',
    country: 'United Kingdom',
    rating: 4.2,
    reviewCount: 87,
    status: 'draft',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2026-01-05T09:00:00Z',
    affiliateUrl: 'https://instantfunding.com/?ref=propfirmhouse',
    startingPrice: 99,
    maxFunding: 100000,
    profitSplit: 80,
  },
  {
    id: '10',
    name: 'Breakout Prop',
    slug: 'breakout-prop',
    logo: 'https://placehold.co/40x40/2A5298/FFF?text=BP',
    country: 'Canada',
    rating: 3.9,
    reviewCount: 56,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-12-22T14:45:00Z',
    affiliateUrl: 'https://breakoutprop.com/?ref=propfirmhouse',
    startingPrice: 119,
    maxFunding: 150000,
    profitSplit: 75,
  },
  {
    id: '11',
    name: 'The Trading Pit',
    slug: 'the-trading-pit',
    logo: 'https://placehold.co/40x40/10B981/FFF?text=TP',
    country: 'United Kingdom',
    rating: 4.4,
    reviewCount: 142,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-09-28T11:15:00Z',
    affiliateUrl: 'https://thetradingpit.com/?ref=propfirmhouse',
    startingPrice: 145,
    maxFunding: 200000,
    profitSplit: 80,
  },
  {
    id: '12',
    name: 'City Traders Imperium',
    slug: 'city-traders-imperium',
    logo: 'https://placehold.co/40x40/F59E0B/FFF?text=CT',
    country: 'United Kingdom',
    rating: 4.6,
    reviewCount: 201,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-10-12T15:30:00Z',
    affiliateUrl: 'https://citytradersimperium.com/?ref=propfirmhouse',
    startingPrice: 169,
    maxFunding: 200000,
    profitSplit: 80,
  },
  {
    id: '13',
    name: 'Funding Pips',
    slug: 'funding-pips',
    logo: 'https://placehold.co/40x40/1A3C6B/FFF?text=FP',
    country: 'United States',
    rating: 4.3,
    reviewCount: 98,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-11-20T12:00:00Z',
    affiliateUrl: 'https://fundingpips.com/?ref=propfirmhouse',
    startingPrice: 125,
    maxFunding: 200000,
    profitSplit: 80,
  },
  {
    id: '14',
    name: 'BrightFunded',
    slug: 'brightfunded',
    logo: 'https://placehold.co/40x40/2A5298/FFF?text=BF',
    country: 'United States',
    rating: 4.5,
    reviewCount: 167,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-12-01T10:20:00Z',
    affiliateUrl: 'https://brightfunded.com/?ref=propfirmhouse',
    startingPrice: 135,
    maxFunding: 250000,
    profitSplit: 80,
  },
  {
    id: '15',
    name: 'Apex Trader Funding',
    slug: 'apex-trader-funding',
    logo: 'https://placehold.co/40x40/10B981/FFF?text=AP',
    country: 'United States',
    rating: 4.7,
    reviewCount: 223,
    status: 'active',
    clicks30d: generateSparklineData(),
    featured: false,
    createdAt: '2025-10-05T09:30:00Z',
    affiliateUrl: 'https://apextraderfunding.com/?ref=propfirmhouse',
    startingPrice: 147,
    maxFunding: 300000,
    profitSplit: 85,
  },
];

export const mockUnlistedFirms = [
  {
    id: '1',
    name: 'QuickFund Pro',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=QF',
    status: 'Delisted',
    reasonSummary: 'Multiple unresolved payout complaints reported by traders since March 2025. Company has stopped responding to customer support tickets.',
    dateFlagged: '2025-12-10T00:00:00Z',
    communityVotes: { trust: 12, distrust: 187 },
    sourceLinks: ['https://example.com/report1', 'https://example.com/report2']
  },
  {
    id: '2',
    name: 'FastTrack Funding',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=FF',
    status: 'Warning',
    reasonSummary: 'Significant delays in payout processing (30+ days). Some traders reporting account restrictions without clear explanation.',
    dateFlagged: '2026-01-02T00:00:00Z',
    communityVotes: { trust: 45, distrust: 89 },
    sourceLinks: ['https://example.com/warning1']
  },
  {
    id: '3',
    name: 'ProFunds Global',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=PG',
    status: 'Unlisted',
    reasonSummary: 'Company voluntarily delisted pending regulatory review. Advised traders to withdraw funds.',
    dateFlagged: '2025-11-28T00:00:00Z',
    communityVotes: { trust: 67, distrust: 34 },
    sourceLinks: ['https://example.com/announcement']
  },
  {
    id: '4',
    name: 'Elite Capital Trading',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=EC',
    status: 'Delisted',
    reasonSummary: 'Website offline, social media accounts deleted, multiple fraud reports filed.',
    dateFlagged: '2025-10-15T00:00:00Z',
    communityVotes: { trust: 5, distrust: 234 },
    sourceLinks: ['https://example.com/fraud-alert']
  },
  {
    id: '5',
    name: 'MaxProfit Funding',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=MP',
    status: 'Warning',
    reasonSummary: 'Changed terms and conditions without notice, affecting existing trader accounts. Under investigation.',
    dateFlagged: '2025-12-28T00:00:00Z',
    communityVotes: { trust: 28, distrust: 72 },
    sourceLinks: []
  },
  {
    id: '6',
    name: 'SwiftTrade Partners',
    logo: 'https://placehold.co/40x40/64748B/FFF?text=ST',
    status: 'Unlisted',
    reasonSummary: 'Ceased operations due to regulatory compliance issues in multiple jurisdictions.',
    dateFlagged: '2025-11-10T00:00:00Z',
    communityVotes: { trust: 89, distrust: 45 },
    sourceLinks: ['https://example.com/regulatory-notice']
  }
];

export const mockUsers = [
  {
    id: '1',
    name: 'John Trader',
    email: 'john@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=John',
    role: 'user',
    tier: 'Elite Trader',
    points: 7845,
    reviewCount: 12,
    verifiedPayouts: 3,
    joined: '2025-06-15T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-08T14:23:00Z'
  },
  {
    id: '2',
    name: 'Sarah Martinez',
    email: 'sarah@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    role: 'user',
    tier: 'Pro Trader',
    points: 4230,
    reviewCount: 8,
    verifiedPayouts: 2,
    joined: '2025-08-22T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T10:15:00Z'
  },
  {
    id: '3',
    name: 'Mike Johnson',
    email: 'mike@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
    role: 'user',
    tier: 'Trader',
    points: 2150,
    reviewCount: 5,
    verifiedPayouts: 1,
    joined: '2025-09-10T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-07T16:40:00Z'
  },
  {
    id: '4',
    name: 'Emma Williams',
    email: 'emma@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    role: 'user',
    tier: 'Pro Trader',
    points: 5680,
    reviewCount: 15,
    verifiedPayouts: 4,
    joined: '2025-05-03T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T09:12:00Z'
  },
  {
    id: '5',
    name: 'David Chen',
    email: 'david@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=David',
    role: 'user',
    tier: 'Starter',
    points: 450,
    reviewCount: 2,
    verifiedPayouts: 0,
    joined: '2025-12-01T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-06T11:30:00Z'
  },
  {
    id: '6',
    name: 'Lisa Anderson',
    email: 'lisa@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lisa',
    role: 'user',
    tier: 'Elite Trader',
    points: 8920,
    reviewCount: 18,
    verifiedPayouts: 5,
    joined: '2025-04-18T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T13:45:00Z'
  },
  {
    id: '7',
    name: 'Robert Taylor',
    email: 'robert@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Robert',
    role: 'user',
    tier: 'Trader',
    points: 1890,
    reviewCount: 4,
    verifiedPayouts: 1,
    joined: '2025-10-05T00:00:00Z',
    status: 'suspended',
    lastActive: '2025-12-20T08:15:00Z'
  },
  {
    id: '8',
    name: 'Jennifer Lee',
    email: 'jennifer@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jennifer',
    role: 'user',
    tier: 'Pro Trader',
    points: 3750,
    reviewCount: 9,
    verifiedPayouts: 2,
    joined: '2025-07-12T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-08T17:20:00Z'
  },
  {
    id: '9',
    name: 'James Wilson',
    email: 'james@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=James',
    role: 'user',
    tier: 'Trader',
    points: 2640,
    reviewCount: 6,
    verifiedPayouts: 1,
    joined: '2025-08-30T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T12:05:00Z'
  },
  {
    id: '10',
    name: 'Maria Garcia',
    email: 'maria@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Maria',
    role: 'user',
    tier: 'Starter',
    points: 780,
    reviewCount: 3,
    verifiedPayouts: 0,
    joined: '2025-11-15T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-07T15:30:00Z'
  },
  {
    id: '11',
    name: 'Chris Brown',
    email: 'chris@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chris',
    role: 'user',
    tier: 'Elite Trader',
    points: 6890,
    reviewCount: 14,
    verifiedPayouts: 4,
    joined: '2025-06-08T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T11:50:00Z'
  },
  {
    id: '12',
    name: 'Amanda White',
    email: 'amanda@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amanda',
    role: 'user',
    tier: 'Pro Trader',
    points: 4120,
    reviewCount: 10,
    verifiedPayouts: 2,
    joined: '2025-07-25T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-08T09:40:00Z'
  },
  {
    id: '13',
    name: 'Daniel Martinez',
    email: 'daniel@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Daniel',
    role: 'user',
    tier: 'Trader',
    points: 1950,
    reviewCount: 5,
    verifiedPayouts: 1,
    joined: '2025-09-20T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-06T14:15:00Z'
  },
  {
    id: '14',
    name: 'Nicole Davis',
    email: 'nicole@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Nicole',
    role: 'user',
    tier: 'Starter',
    points: 340,
    reviewCount: 1,
    verifiedPayouts: 0,
    joined: '2025-12-10T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-05T10:20:00Z'
  },
  {
    id: '15',
    name: 'Kevin Thomas',
    email: 'kevin@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Kevin',
    role: 'user',
    tier: 'Elite Trader',
    points: 7320,
    reviewCount: 16,
    verifiedPayouts: 3,
    joined: '2025-05-28T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T16:30:00Z'
  },
  {
    id: '16',
    name: 'Rachel Moore',
    email: 'rachel@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rachel',
    role: 'user',
    tier: 'Trader',
    points: 2890,
    reviewCount: 7,
    verifiedPayouts: 1,
    joined: '2025-08-14T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-08T13:10:00Z'
  },
  {
    id: '17',
    name: 'Brian Jackson',
    email: 'brian@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Brian',
    role: 'user',
    tier: 'Pro Trader',
    points: 5240,
    reviewCount: 11,
    verifiedPayouts: 3,
    joined: '2025-06-30T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T10:55:00Z'
  },
  {
    id: '18',
    name: 'Stephanie Harris',
    email: 'stephanie@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Stephanie',
    role: 'user',
    tier: 'Starter',
    points: 620,
    reviewCount: 2,
    verifiedPayouts: 0,
    joined: '2025-11-22T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-07T12:45:00Z'
  },
  {
    id: '19',
    name: 'Matthew Clark',
    email: 'matthew@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Matthew',
    role: 'user',
    tier: 'Trader',
    points: 3120,
    reviewCount: 8,
    verifiedPayouts: 2,
    joined: '2025-07-18T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-09T14:20:00Z'
  },
  {
    id: '20',
    name: 'Lauren Rodriguez',
    email: 'lauren@example.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lauren',
    role: 'user',
    tier: 'Pro Trader',
    points: 4670,
    reviewCount: 10,
    verifiedPayouts: 2,
    joined: '2025-07-05T00:00:00Z',
    status: 'active',
    lastActive: '2026-01-08T11:35:00Z'
  }
];

export const mockReviews = [
  {
    id: '1',
    userId: '1',
    firmId: '1',
    rating: 5,
    reviewText: 'FTMO has been excellent. The evaluation was fair, support was responsive, and I got my first payout within 3 days. Highly recommend for serious traders.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 4, rules: 5 },
    helpful: 45,
    notHelpful: 3,
    createdAt: '2025-12-15T10:30:00Z',
  },
  {
    id: '2',
    userId: '2',
    firmId: '1',
    rating: 4,
    reviewText: 'Good firm overall. The challenge is tough but fair. Platform is solid and MT4/MT5 work well. Only issue was a slight delay in customer support response.',
    status: 'approved',
    subRatings: { support: 3, payouts: 5, platform: 4, rules: 4 },
    helpful: 32,
    notHelpful: 2,
    createdAt: '2025-12-20T14:15:00Z',
  },
  {
    id: '3',
    userId: '3',
    firmId: '3',
    rating: 5,
    reviewText: 'Funded Next is amazing! Got instant funding option, no waiting around. Payouts are fast and the profit split is generous. Best prop firm I have used.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 4 },
    helpful: 67,
    notHelpful: 1,
    createdAt: '2025-12-25T09:45:00Z',
  },
  {
    id: '4',
    userId: '4',
    firmId: '2',
    rating: 3,
    reviewText: 'The5ers is okay but nothing special. Rules are strict and the drawdown limits are tight. Passed the challenge but found better options elsewhere.',
    status: 'approved',
    subRatings: { support: 3, payouts: 4, platform: 3, rules: 2 },
    helpful: 18,
    notHelpful: 8,
    createdAt: '2026-01-02T11:20:00Z',
  },
  {
    id: '5',
    userId: '5',
    firmId: '4',
    rating: 2,
    reviewText: 'Had issues with MyFundedFX. Platform kept disconnecting during high volatility. Support took 2 days to respond. Not impressed.',
    status: 'pending',
    subRatings: { support: 2, payouts: 0, platform: 2, rules: 3 },
    helpful: 0,
    notHelpful: 0,
    createdAt: '2026-01-06T16:30:00Z',
  },
  {
    id: '6',
    userId: '6',
    firmId: '7',
    rating: 5,
    reviewText: 'Alpha Capital exceeded all expectations. Professional team, clear rules, and lightning-fast payouts. This is what a prop firm should be.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 5 },
    helpful: 89,
    notHelpful: 2,
    createdAt: '2025-12-28T13:10:00Z',
  },
  {
    id: '7',
    userId: '7',
    firmId: '5',
    rating: 4,
    reviewText: 'Topstep for futures is solid. Good platform integration with NinjaTrader. Evaluation is challenging but teaches you discipline.',
    status: 'approved',
    subRatings: { support: 4, payouts: 4, platform: 5, rules: 4 },
    helpful: 41,
    notHelpful: 5,
    createdAt: '2025-12-18T10:05:00Z',
  },
  {
    id: '8',
    userId: '8',
    firmId: '8',
    rating: 3,
    reviewText: 'E8 Markets is average. Nothing wrong with them but nothing stands out either. Passed my evaluation without issues.',
    status: 'approved',
    subRatings: { support: 3, payouts: 4, platform: 3, rules: 3 },
    helpful: 12,
    notHelpful: 4,
    createdAt: '2026-01-04T15:40:00Z',
  },
  {
    id: '9',
    userId: '9',
    firmId: '1',
    rating: 1,
    reviewText: 'This is fake, FTMO is a scam!!! They closed my account for no reason!!! DO NOT USE!!!',
    status: 'flagged',
    subRatings: { support: 1, payouts: 1, platform: 1, rules: 1 },
    helpful: 2,
    notHelpful: 45,
    flagReason: 'Suspected fake review, inflammatory language, contradicts established firm reputation',
    createdAt: '2026-01-07T18:20:00Z',
  },
  {
    id: '10',
    userId: '10',
    firmId: '3',
    rating: 4,
    reviewText: 'Really happy with Funded Next. The process was smooth and I got funded quickly. Support team is friendly and helpful.',
    status: 'approved',
    subRatings: { support: 5, payouts: 4, platform: 4, rules: 4 },
    helpful: 28,
    notHelpful: 1,
    createdAt: '2025-12-30T12:15:00Z',
  },
  {
    id: '11',
    userId: '11',
    firmId: '12',
    rating: 5,
    reviewText: 'City Traders Imperium is top-notch. Great customer service, fair rules, and they actually want you to succeed. Been with them 6 months now.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 4, rules: 5 },
    helpful: 56,
    notHelpful: 2,
    createdAt: '2025-12-22T09:30:00Z',
  },
  {
    id: '12',
    userId: '12',
    firmId: '13',
    rating: 4,
    reviewText: 'Funding Pips delivered on their promises. Clean platform, reasonable rules, and fast payouts. Would recommend to other traders.',
    status: 'pending',
    subRatings: { support: 4, payouts: 5, platform: 4, rules: 4 },
    helpful: 0,
    notHelpful: 0,
    createdAt: '2026-01-08T14:50:00Z',
  },
  {
    id: '13',
    userId: '13',
    firmId: '14',
    rating: 5,
    reviewText: 'BrightFunded is brilliant! Low entry cost, high profit split, and excellent support. This is my third funded account with them.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 4 },
    helpful: 72,
    notHelpful: 3,
    createdAt: '2025-12-19T11:40:00Z',
  },
  {
    id: '14',
    userId: '14',
    firmId: '6',
    rating: 3,
    reviewText: 'True Forex Funds is decent. Nothing amazing but they pay on time. Platform could use some updates.',
    status: 'approved',
    subRatings: { support: 3, payouts: 4, platform: 3, rules: 3 },
    helpful: 15,
    notHelpful: 7,
    createdAt: '2026-01-03T16:25:00Z',
  },
  {
    id: '15',
    userId: '15',
    firmId: '15',
    rating: 5,
    reviewText: 'Apex Trader Funding for futures is the best in the business. Professional operation, clear communication, generous scaling plan.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 5 },
    helpful: 94,
    notHelpful: 1,
    createdAt: '2025-12-16T10:55:00Z',
  },
  {
    id: '16',
    userId: '16',
    firmId: '11',
    rating: 4,
    reviewText: 'The Trading Pit has been reliable. Good challenge structure and they process payouts within a week. Happy customer here.',
    status: 'approved',
    subRatings: { support: 4, payouts: 4, platform: 4, rules: 4 },
    helpful: 34,
    notHelpful: 2,
    createdAt: '2025-12-27T13:20:00Z',
  },
  {
    id: '17',
    userId: '17',
    firmId: '7',
    rating: 5,
    reviewText: 'Alpha Capital is fantastic. Transparent rules, supportive staff, and they genuinely care about trader success. Can\'t fault them.',
    status: 'pending',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 5 },
    helpful: 0,
    notHelpful: 0,
    createdAt: '2026-01-09T10:10:00Z',
  },
  {
    id: '18',
    userId: '18',
    firmId: '1',
    rating: 4,
    reviewText: 'FTMO is solid. The evaluation process is tough but it prepares you well. Got my first payout last week with no issues.',
    status: 'approved',
    subRatings: { support: 4, payouts: 5, platform: 4, rules: 4 },
    helpful: 38,
    notHelpful: 3,
    createdAt: '2025-12-31T15:30:00Z',
  },
  {
    id: '19',
    userId: '19',
    firmId: '3',
    rating: 5,
    reviewText: 'Funded Next is my go-to recommendation. Easy signup, fast approval, and the dashboard is user-friendly. Five stars all the way.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 4 },
    helpful: 63,
    notHelpful: 2,
    createdAt: '2026-01-01T09:45:00Z',
  },
  {
    id: '20',
    userId: '20',
    firmId: '12',
    rating: 4,
    reviewText: 'City Traders Imperium offers great value. The profit split is competitive and support team is always available to help.',
    status: 'approved',
    subRatings: { support: 5, payouts: 4, platform: 4, rules: 4 },
    helpful: 29,
    notHelpful: 4,
    createdAt: '2026-01-05T12:05:00Z',
  },
  {
    id: '21',
    userId: '4',
    firmId: '14',
    rating: 3,
    reviewText: 'BrightFunded is okay. Had a small issue with verification but it got resolved. Platform works fine.',
    status: 'pending',
    subRatings: { support: 3, payouts: 4, platform: 3, rules: 3 },
    helpful: 0,
    notHelpful: 0,
    createdAt: '2026-01-08T17:30:00Z',
  },
  {
    id: '22',
    userId: '2',
    firmId: '8',
    rating: 4,
    reviewText: 'E8 Markets has improved a lot recently. New features and better support response times. Worth considering.',
    status: 'approved',
    subRatings: { support: 4, payouts: 4, platform: 4, rules: 4 },
    helpful: 22,
    notHelpful: 3,
    createdAt: '2025-12-29T11:15:00Z',
  },
  {
    id: '23',
    userId: '6',
    firmId: '5',
    rating: 5,
    reviewText: 'Topstep helped me become a better trader. The evaluation teaches discipline and risk management. Highly educational.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 5 },
    helpful: 78,
    notHelpful: 4,
    createdAt: '2025-12-24T14:40:00Z',
  },
  {
    id: '24',
    userId: '11',
    firmId: '15',
    rating: 5,
    reviewText: 'Apex is the gold standard. Everything works as advertised. Best prop firm experience I have had.',
    status: 'approved',
    subRatings: { support: 5, payouts: 5, platform: 5, rules: 5 },
    helpful: 85,
    notHelpful: 1,
    createdAt: '2025-12-21T10:20:00Z',
  },
  {
    id: '25',
    userId: '15',
    firmId: '13',
    rating: 4,
    reviewText: 'Funding Pips delivers consistent service. No complaints, just steady reliable performance. Good firm.',
    status: 'pending',
    subRatings: { support: 4, payouts: 4, platform: 4, rules: 4 },
    helpful: 0,
    notHelpful: 0,
    createdAt: '2026-01-09T09:25:00Z',
  },
];

export const mockBlogPosts = [
  {
    id: '1',
    title: 'Best Prop Firms for Beginners 2026',
    slug: 'best-prop-firms-beginners-2026',
    excerpt: 'Starting your prop trading journey? Here are the most beginner-friendly firms with the best support and fair evaluation processes.',
    content: '<p>Full article content here...</p>',
    contentType: 'blog',
    category: 'Reviews',
    tags: ['Beginners', 'Prop Firms', '2026'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/1A3C6B/FFF?text=Beginners+Guide',
    readingTime: 8,
    publishedAt: '2025-12-20T10:00:00Z',
    createdAt: '2025-12-18T14:00:00Z',
  },
  {
    id: '2',
    title: 'FTMO vs Funded Next 2026 Comparison',
    slug: 'ftmo-vs-funded-next-comparison',
    excerpt: 'An in-depth comparison of two of the most popular prop firms. Which one is right for you?',
    content: '<p>Full comparison content...</p>',
    contentType: 'blog',
    category: 'Reviews',
    tags: ['FTMO', 'Funded Next', 'Comparison'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/2A5298/FFF?text=FTMO+vs+Funded+Next',
    readingTime: 12,
    publishedAt: '2025-12-28T09:00:00Z',
    createdAt: '2025-12-26T11:00:00Z',
  },
  {
    id: '3',
    title: '1-Step vs 2-Step Challenges Explained',
    slug: '1-step-vs-2-step-challenges',
    excerpt: 'Understanding the difference between instant funding and traditional evaluation processes.',
    content: '<p>Challenge explanation content...</p>',
    contentType: 'resource',
    category: 'Guides',
    tags: ['Challenges', 'Evaluation', 'Guide'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/10B981/FFF?text=Challenge+Types',
    readingTime: 6,
    publishedAt: '2026-01-02T11:00:00Z',
    createdAt: '2025-12-30T15:00:00Z',
  },
  {
    id: '4',
    title: 'How to Pass Your First Prop Firm Challenge',
    slug: 'pass-first-prop-firm-challenge',
    excerpt: 'Proven strategies and tips to successfully complete your evaluation and get funded.',
    content: '<p>Strategy content...</p>',
    contentType: 'resource',
    category: 'Strategy',
    tags: ['Tips', 'Strategy', 'Challenge'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/F59E0B/FFF?text=Pass+Challenge',
    readingTime: 10,
    publishedAt: '2025-12-15T10:00:00Z',
    createdAt: '2025-12-12T09:00:00Z',
  },
  {
    id: '5',
    title: 'Top 10 Prop Firms of 2026',
    slug: 'top-10-prop-firms-2026',
    excerpt: 'Our comprehensive ranking of the best proprietary trading firms based on reviews, payouts, and trader satisfaction.',
    content: '<p>Ranking content...</p>',
    contentType: 'blog',
    category: 'Reviews',
    tags: ['Rankings', '2026', 'Top 10'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'draft',
    featuredImage: 'https://placehold.co/800x450/1A3C6B/FFF?text=Top+10',
    readingTime: 15,
    createdAt: '2026-01-05T13:00:00Z',
  },
  {
    id: '6',
    title: 'Understanding Drawdown Rules',
    slug: 'understanding-drawdown-rules',
    excerpt: 'A complete guide to trailing drawdown, static drawdown, and end-of-day drawdown rules.',
    content: '<p>Drawdown explanation...</p>',
    contentType: 'resource',
    category: 'Guides',
    tags: ['Drawdown', 'Rules', 'Guide'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/2A5298/FFF?text=Drawdown+Guide',
    readingTime: 7,
    publishedAt: '2025-12-22T14:00:00Z',
    createdAt: '2025-12-20T10:00:00Z',
  },
  {
    id: '7',
    title: 'Prop Firm Red Flags to Avoid',
    slug: 'prop-firm-red-flags',
    excerpt: 'Learn how to identify potentially problematic prop firms before you invest your money.',
    content: '<p>Red flags content...</p>',
    contentType: 'blog',
    category: 'Guides',
    tags: ['Safety', 'Red Flags', 'Warning'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/EF4444/FFF?text=Red+Flags',
    readingTime: 9,
    publishedAt: '2026-01-06T10:00:00Z',
    createdAt: '2026-01-04T12:00:00Z',
  },
  {
    id: '8',
    title: 'Profit Split Calculator Tool',
    slug: 'profit-split-calculator',
    excerpt: 'Calculate your potential earnings with different profit splits and account sizes.',
    contentType: 'resource',
    content: '<p>Calculator tool...</p>',
    category: 'Tools',
    tags: ['Calculator', 'Tool', 'Profit'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'scheduled',
    featuredImage: 'https://placehold.co/800x450/10B981/FFF?text=Calculator',
    readingTime: 4,
    scheduledFor: '2026-01-12T10:00:00Z',
    createdAt: '2026-01-07T16:00:00Z',
  },
  {
    id: '9',
    title: 'How Prop Firm Payouts Work',
    slug: 'how-prop-firm-payouts-work',
    excerpt: 'Everything you need to know about requesting, processing, and receiving your trading profits.',
    content: '<p>Payout process content...</p>',
    contentType: 'resource',
    category: 'Guides',
    tags: ['Payouts', 'Process', 'Guide'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/F59E0B/FFF?text=Payouts',
    readingTime: 8,
    publishedAt: '2025-12-18T11:00:00Z',
    createdAt: '2025-12-16T14:00:00Z',
  },
  {
    id: '10',
    title: 'The Psychology of Prop Trading',
    slug: 'psychology-prop-trading',
    excerpt: 'Mental strategies and mindset tips for succeeding in prop firm evaluations and funded accounts.',
    content: '<p>Psychology content...</p>',
    contentType: 'blog',
    category: 'Strategy',
    tags: ['Psychology', 'Mindset', 'Strategy'],
    author: 'Admin Team',
    authorAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Admin',
    status: 'published',
    featuredImage: 'https://placehold.co/800x450/2A5298/FFF?text=Psychology',
    readingTime: 11,
    publishedAt: '2025-12-25T09:00:00Z',
    createdAt: '2025-12-23T13:00:00Z',
  },
];

export const mockNewsItems = [
  {
    id: '1',
    firmId: '1',
    title: 'FTMO Reduces Minimum Trading Days to 4',
    body: 'FTMO has announced a reduction in minimum trading days requirement from 5 to 4 for all Swing trading accounts, effective immediately.',
    publishedAt: '2026-01-05T10:00:00Z',
    status: 'published',
    createdAt: '2026-01-04T15:00:00Z',
  },
  {
    id: '2',
    firmId: '3',
    title: 'Funded Next Launches $500K Account Tier',
    body: 'Funded Next introduces new $500,000 account size with 90% profit split for experienced traders. Applications open next week.',
    publishedAt: '2026-01-07T11:00:00Z',
    status: 'published',
    createdAt: '2026-01-06T14:00:00Z',
  },
  {
    id: '3',
    firmId: '7',
    title: 'Alpha Capital Partners with TradingView',
    body: 'Alpha Capital announces integration with TradingView platform, allowing traders to connect their funded accounts directly.',
    publishedAt: '2025-12-28T09:00:00Z',
    status: 'published',
    createdAt: '2025-12-27T16:00:00Z',
  },
  {
    id: '4',
    firmId: '15',
    title: 'Apex Trader Funding Adds Crypto Futures',
    body: 'Apex expands offerings to include Bitcoin and Ethereum futures trading on all funded accounts starting February 2026.',
    publishedAt: '2026-01-08T13:00:00Z',
    status: 'published',
    createdAt: '2026-01-08T09:00:00Z',
  },
  {
    id: '5',
    firmId: '12',
    title: 'City Traders Imperium Holiday Promotion',
    body: 'Special 20% discount on all challenge fees through January 15th. Use code NEWYEAR2026 at checkout.',
    publishedAt: '2026-01-02T10:00:00Z',
    status: 'published',
    createdAt: '2026-01-01T12:00:00Z',
  },
  {
    id: '6',
    firmId: '14',
    title: 'BrightFunded Achieves $10M in Payouts',
    body: 'BrightFunded celebrates milestone of $10 million paid to traders in 2025, with average payout time of 2.1 days.',
    publishedAt: '2025-12-30T14:00:00Z',
    status: 'published',
    createdAt: '2025-12-29T11:00:00Z',
  },
  {
    id: '7',
    firmId: '5',
    title: 'Topstep Introduces AI Risk Management Tool',
    body: 'New AI-powered risk analysis dashboard helps traders identify patterns and improve their performance during evaluations.',
    publishedAt: '2025-12-20T10:00:00Z',
    status: 'published',
    createdAt: '2025-12-19T15:00:00Z',
  },
  {
    id: '8',
    firmId: '2',
    title: 'The5ers Expands to Asian Markets',
    body: 'The5ers announces support for Asian trading hours and new partnerships with brokers in Singapore and Hong Kong.',
    publishedAt: '2025-12-15T09:00:00Z',
    status: 'published',
    createdAt: '2025-12-14T13:00:00Z',
  },
  {
    id: '9',
    firmId: '11',
    title: 'The Trading Pit Updates Scaling Plan',
    body: 'New scaling plan allows traders to grow accounts up to $1M based on consistent performance. Details coming soon.',
    status: 'draft',
    createdAt: '2026-01-09T10:00:00Z',
  },
  {
    id: '10',
    firmId: '8',
    title: 'E8 Markets Improves Customer Support',
    body: 'E8 Markets launches 24/7 live chat support and reduces average response time to under 2 hours for all inquiries.',
    publishedAt: '2026-01-06T12:00:00Z',
    status: 'published',
    createdAt: '2026-01-05T16:00:00Z',
  },
];

export const mockVerifiedPayouts = [
  {
    id: '1',
    userId: '1',
    firmId: '1',
    amount: 4250.00,
    method: 'Bank Wire',
    payoutDate: '2026-01-02T00:00:00Z',
    submittedAt: '2026-01-03T10:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Bank+Statement',
    status: 'verified',
    notes: 'First payout, received within 3 days as promised',
  },
  {
    id: '2',
    userId: '4',
    firmId: '7',
    amount: 8920.50,
    method: 'Crypto',
    payoutDate: '2025-12-28T00:00:00Z',
    submittedAt: '2025-12-29T14:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Crypto+Transaction',
    status: 'verified',
  },
  {
    id: '3',
    userId: '6',
    firmId: '15',
    amount: 12480.00,
    method: 'Wise',
    payoutDate: '2025-12-30T00:00:00Z',
    submittedAt: '2025-12-31T09:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Wise+Receipt',
    status: 'verified',
  },
  {
    id: '4',
    userId: '11',
    firmId: '12',
    amount: 6750.00,
    method: 'Bank Wire',
    payoutDate: '2026-01-04T00:00:00Z',
    submittedAt: '2026-01-05T11:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Bank+Confirmation',
    status: 'verified',
  },
  {
    id: '5',
    userId: '15',
    firmId: '13',
    amount: 3200.00,
    method: 'PayPal',
    payoutDate: '2026-01-05T00:00:00Z',
    submittedAt: '2026-01-06T13:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=PayPal+Receipt',
    status: 'pending',
    notes: 'Awaiting verification from admin',
  },
  {
    id: '6',
    userId: '2',
    firmId: '3',
    amount: 5890.00,
    method: 'Deel',
    payoutDate: '2026-01-06T00:00:00Z',
    submittedAt: '2026-01-07T10:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Deel+Confirmation',
    status: 'pending',
  },
  {
    id: '7',
    userId: '8',
    firmId: '14',
    amount: 7640.00,
    method: 'Bank Wire',
    payoutDate: '2025-12-26T00:00:00Z',
    submittedAt: '2025-12-27T15:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Bank+Statement',
    status: 'verified',
  },
  {
    id: '8',
    userId: '17',
    firmId: '7',
    amount: 15200.00,
    method: 'Crypto',
    payoutDate: '2025-12-22T00:00:00Z',
    submittedAt: '2025-12-23T09:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=BTC+Transaction',
    status: 'verified',
  },
  {
    id: '9',
    userId: '19',
    firmId: '3',
    amount: 9320.00,
    method: 'Wise',
    payoutDate: '2025-12-29T00:00:00Z',
    submittedAt: '2025-12-30T12:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Wise+Transfer',
    status: 'verified',
  },
  {
    id: '10',
    userId: '3',
    firmId: '1',
    amount: 2100.00,
    method: 'PayPal',
    payoutDate: '2026-01-07T00:00:00Z',
    submittedAt: '2026-01-08T14:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=PayPal+Screenshot',
    status: 'pending',
  },
  {
    id: '11',
    userId: '12',
    firmId: '11',
    amount: 4580.00,
    method: 'Bank Wire',
    payoutDate: '2025-12-18T00:00:00Z',
    submittedAt: '2025-12-19T10:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Bank+Proof',
    status: 'verified',
  },
  {
    id: '12',
    userId: '1',
    firmId: '1',
    amount: 6890.00,
    method: 'Bank Wire',
    payoutDate: '2025-12-15T00:00:00Z',
    submittedAt: '2025-12-16T11:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Second+Payout',
    status: 'verified',
  },
  {
    id: '13',
    userId: '6',
    firmId: '15',
    amount: 18950.00,
    method: 'Crypto',
    payoutDate: '2025-12-20T00:00:00Z',
    submittedAt: '2025-12-21T09:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Large+Crypto+Payout',
    status: 'verified',
  },
  {
    id: '14',
    userId: '9',
    firmId: '5',
    amount: 3450.00,
    method: 'Rise',
    payoutDate: '2026-01-03T00:00:00Z',
    submittedAt: '2026-01-04T13:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Rise+Payment',
    status: 'rejected',
    notes: 'Proof document unclear, resubmission requested',
  },
  {
    id: '15',
    userId: '20',
    firmId: '12',
    amount: 5120.00,
    method: 'Wise',
    payoutDate: '2025-12-27T00:00:00Z',
    submittedAt: '2025-12-28T14:00:00Z',
    proofUrl: 'https://placehold.co/600x400?text=Wise+Confirmation',
    status: 'verified',
  },
];

export const mockAnnouncements = [
  {
    id: '1',
    message: '🎉 PropFirmHouse launches new Verified Payouts section! See real trader earnings.',
    linkUrl: '/verified-payouts',
    color: 'green',
    startDate: '2026-01-01T00:00:00Z',
    endDate: '2026-01-31T23:59:59Z',
    displayDuration: 8,
    gap: 2,
    dismissible: true,
    priority: 1,
    active: true,
    status: 'live',
  },
  {
    id: '2',
    message: 'Limited time 20% off challenge fees at selected firms. Check our deals page!',
    linkUrl: '/deals',
    color: 'amber',
    startDate: '2026-01-08T00:00:00Z',
    endDate: '2026-01-15T23:59:59Z',
    displayDuration: 10,
    gap: 2,
    dismissible: false,
    priority: 2,
    active: true,
    status: 'live',
  },
  {
    id: '3',
    message: 'New review vs Funded Next comparison is now live. Read full analysis.',
    linkUrl: '/blog/ftmo-vs-funded-next-comparison',
    color: 'blue',
    startDate: '2025-12-28T00:00:00Z',
    endDate: '2026-01-10T23:59:59Z',
    displayDuration: 7,
    gap: 2,
    dismissible: true,
    priority: 3,
    active: true,
    status: 'live',
  },
  {
    id: '4',
    message: 'Join our loyalty program and earn points for every review. Redeem for exclusive rewards!',
    linkUrl: '/loyalty',
    color: 'purple',
    startDate: '2026-01-15T00:00:00Z',
    endDate: '2026-02-15T23:59:59Z',
    displayDuration: 9,
    gap: 2,
    dismissible: true,
    priority: 4,
    active: true,
    status: 'scheduled',
  },
  {
    id: '5',
    message: '⚠️ WARNING Pro has been delisted due to multiple complaints. See details.',
    linkUrl: '/unlisted-firms',
    color: 'red',
    startDate: '2025-12-10T00:00:00Z',
    endDate: '2026-01-10T23:59:59Z',
    displayDuration: 12,
    gap: 3,
    dismissible: false,
    priority: 0,
    active: true,
    status: 'live',
  },
];

export const mockActivities = [
  {
    id: '1',
    type: 'payout_verified',
    description: 'John Trader verified payout of $4,250 from FTMO',
    timestamp: '2026-01-09T14:23:00Z',
    color: 'green',
  },
  {
    id: '2',
    type: 'review_approved',
    description: 'Review of BrightFunded by Sarah Martinez approved',
    timestamp: '2026-01-09T13:15:00Z',
    color: 'green',
  },
  {
    id: '3',
    type: 'user_registered',
    description: 'New user Lauren Rodriguez joined',
    timestamp: '2026-01-09T12:05:00Z',
    color: 'purple',
  },
  {
    id: '4',
    type: 'firm_added',
    description: 'New firm Apex Trader Funding added to directory',
    timestamp: '2026-01-09T10:30:00Z',
    color: 'blue',
  },
  {
    id: '5',
    type: 'news_published',
    description: 'News published Trader Funding Adds Crypto Futures',
    timestamp: '2026-01-08T13:00:00Z',
    color: 'slate',
  },
  {
    id: '6',
    type: 'review_flagged',
    description: 'Review of FTMO by Mike Johnson flagged for review',
    timestamp: '2026-01-07T18:20:00Z',
    color: 'red',
  },
  {
    id: '7',
    type: 'payout_verified',
    description: 'Emma Williams verified payout of $5,890 from Funded Next',
    timestamp: '2026-01-07T10:00:00Z',
    color: 'green',
  },
  {
    id: '8',
    type: 'firm_warned',
    description: 'FastTrack Funding moved to Warning status',
    timestamp: '2026-01-02T00:00:00Z',
    color: 'amber',
  },
  {
    id: '9',
    type: 'review_approved',
    description: 'Review of Alpha Capital by Lisa Anderson approved',
    timestamp: '2025-12-28T13:10:00Z',
    color: 'green',
  },
  {
    id: '10',
    type: 'user_registered',
    description: 'New user Matthew Clark joined',
    timestamp: '2025-12-27T16:40:00Z',
    color: 'purple',
  },
  {
    id: '11',
    type: 'payout_verified',
    description: 'Lisa Anderson verified payout of $18,950 from Apex Trader Funding',
    timestamp: '2025-12-21T09:00:00Z',
    color: 'green',
  },
  {
    id: '12',
    type: 'firm_added',
    description: 'New firm City Traders Imperium added to directory',
    timestamp: '2025-12-20T14:45:00Z',
    color: 'blue',
  },
  {
    id: '13',
    type: 'news_published',
    description: 'News published Introduces AI Risk Management Tool',
    timestamp: '2025-12-20T10:00:00Z',
    color: 'slate',
  },
  {
    id: '14',
    type: 'review_approved',
    description: 'Review of Funded Next by Rachel Moore approved',
    timestamp: '2025-12-18T10:05:00Z',
    color: 'green',
  },
  {
    id: '15',
    type: 'firm_warned',
    description: 'QuickFund Pro moved to Delisted status',
    timestamp: '2025-12-10T00:00:00Z',
    color: 'red',
  },
];

// Utility functions
export const getFirmById = (id) => {
  return mockPropFirms.find(firm => firm.id === id);
};

export const getUserById = (id) => {
  return mockUsers.find(user => user.id === id);
};

export const getReviewsByFirmId = (firmId) => {
  return mockReviews.filter(review => review.firmId === firmId);
};

export const getReviewsByUserId = (userId) => {
  return mockReviews.filter(review => review.userId === userId);
};

export const getPendingReviews = () => {
  return mockReviews.filter(review => review.status === 'pending');
};

export const getPendingPayouts = () => {
  return mockVerifiedPayouts.filter(payout => payout.status === 'pending');
};
